export const rapsRed = '#A71930';
export const rapsRedHover = '#B33748';
export const rapsRedActive = '#800d24';
export const dinOffcPro = 'DIN Offc Pro';

// Bottom / Top navigation bar
export const topBarBreakPoint = '773px';
export const activeNavLinkColor = '#a7182f';
